import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ImportIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
    />
  </BaseIcon>
)
